import { immerable } from "immer";
import { Expose, Type, Transform } from "class-transformer";
import { fromJson } from "./json";

import { ProductName } from "@airhelp/plus";
import { TransformStringToEnum } from "./transformers";

export interface IPrice {
  code: string;
  price: number;
}

export interface IOffer {
  id: number | null;
  name: string | ProductName;
  displayName?: string;
  paymentFrequency?: string | null;
  prices: IPrice[];
}

class Price {
  @Expose() code: string;
  @Expose() price: string;
}

class Offer implements IOffer {
  @Expose() id: number | null;
  @TransformStringToEnum(ProductName) @Expose() name: ProductName;
  @Expose() displayName?: string;
  @Expose() paymentFrequency?: string | null;
  @Expose()
  @Type(() => Price)
  @Transform(({ obj, key }) => Object.values(obj[key]))
  prices: IPrice[];
}

export class AhPlusOffersRest {
  [immerable] = true;

  @Expose() canBuyPlus: boolean;
  @Expose()
  @Type(() => Offer)
  @Transform(({ value }) => value ?? [])
  offers: IOffer[];

  static fromJson(data: any) {
    return fromJson(AhPlusOffersRest, data);
  }
}
